import React from 'react'
import { Screen, Header } from '@components'
import { useQRCode } from './hook'
import { useScreen } from '@hooks'
import { QRCodeContent } from './QRCodeContent'
import { useLanguage } from '@context'

export const QRCode: React.FC = () => {
  const { isWeb } = useScreen()
  const { navigation } = useQRCode()
  const { t } = useLanguage()

  return (
    <Screen>
      <Header
        title={t('qrCodeScan.headerTitle')}
        iconLeft={isWeb ? undefined : 'arrowBack'}
        iconRight='scan'
        onPressRight={() => navigation.navigate('Scan')}
      />
      <QRCodeContent />
    </Screen>
  )
}
